import React from 'react'
import AppContext from 'AppContext'
import { env, featureEnabled, hasAccess } from 'components/Helpers'

const screens = [
  { hash: '', tag: 'cl-location-list' },
  { hash: 'locations', tag: 'cl-location-list' },
  { hash: 'create-location', tag: 'cl-create-location' },
  { hash: 'region-list', tag: 'cl-region-list' },
  { hash: 'create-region', tag: 'cl-create-region' },
  { hash: 'update-region', tag: 'cl-update-region' }
]

function currentHash () {
  return window.location.hash.replace('#', '').split('/')[0]
}

function currentHashParam () {
  const parts = window.location.hash.replace('#', '').split('/')
  return parts[1] || null
}

const LocationsWrapper = ({ match }) => {
  const [hash, setHash] = React.useState(currentHash())
  const regionRef = React.useRef(null)
  const listRef = React.useRef(null)

  const token = window.localStorage.getItem('auth-token')
  const { operator, user } = React.useContext(AppContext)

  React.useEffect(() => {
    const onHashChange = () => setHash(currentHash())
    window.addEventListener('hashchange', onHashChange)
    return () => window.removeEventListener('hashchange', onHashChange)
  }, [])

  React.useEffect(() => {
    const onLocationCreated = () => {
      window.location.hash = ''
    }
    window.addEventListener('location-created', onLocationCreated)
    return () => window.removeEventListener('location-created', onLocationCreated)
  }, [])

  React.useEffect(() => {
    if (hash === 'update-region' && regionRef.current) {
      regionRef.current.regionId = currentHashParam()
    }
  }, [hash])

  React.useEffect(() => {
    if (listRef.current) {
      listRef.current.mountPath = match.url.replace(':operatorID', operator.id)
    }
  })

  if (!operator.id) {
    return (
      <div className='index locations'>
        <p>waiting for operator...</p>
      </div>
    )
  }

  const apiHost = `https://operators.${env()}.credlock.net`
  const mountPath = match.url.replace(':operatorID', operator.id)

  const visible = (tag) => {
    const active = hash || ''
    const screenDef = screens.find(s => s.tag === tag && s.hash === active)
    if (screenDef) return true
    if (tag === 'cl-location-list' && active === '') return true
    return false
  }

  return (
    <div className='index locations'>
      {/* eslint-disable-next-line */}
      <h1></h1>
      <div style={{ display: visible('cl-location-list') ? 'block' : 'none' }}>
        <cl-location-list
          ref={listRef}
          apiHost={apiHost}
          operatorId={operator.id}
          token={token}
          mountPath={mountPath}
        >
          {featureEnabled('locationMonitor', operator.id) && hasAccess(user, 'location_monitor.view_settings') && (
            <cl-button
              slot='actions'
              label='Manage Alerts'
              icon='notifications'
              variant='secondary'
              to={`/operators/${operator.id}/location-monitor/locations`}
            />
          )}
        </cl-location-list>
      </div>
      <div style={{ display: visible('cl-create-location') ? 'block' : 'none' }}>
        <cl-create-location
          apiHost={apiHost}
          operatorId={operator.id}
          token={token}
        />
      </div>
      <div style={{ display: visible('cl-region-list') ? 'block' : 'none' }}>
        <cl-region-list
          apiHost={apiHost}
          operatorId={operator.id}
          token={token}
        />
      </div>
      <div style={{ display: visible('cl-create-region') ? 'block' : 'none' }}>
        <cl-create-region
          apiHost={apiHost}
          operatorId={operator.id}
          token={token}
        />
      </div>
      <div style={{ display: visible('cl-update-region') ? 'block' : 'none' }}>
        <cl-update-region
          ref={regionRef}
          apiHost={apiHost}
          operatorId={operator.id}
          token={token}
        />
      </div>
    </div>
  )
}

export default LocationsWrapper
